import Tooltip from 'antd/lib/tooltip'
import InfoCircleFilled from '@ant-design/icons/lib/icons/InfoCircleFilled'
import styles from './InfoTooltip.module.less'
import { ReactNode } from 'react'

export type InfoTooltipPropsType = {
    placement?:
        | 'top'
        | 'left'
        | 'bottom'
        | 'right'
        | 'topLeft'
        | 'topRight'
        | 'bottomLeft'
        | 'bottomRight'
    title: string | ReactNode
    color?: 'default' | 'light'
    maxWidth?: string
}

const InfoTooltip = (props: InfoTooltipPropsType) => {
    return (
        <Tooltip
            placement={props.placement ?? 'top'}
            color={props.color === 'light' ? '#fff' : ''}
            overlayInnerStyle={{ color: props.color === 'light' ? '#000' : '' }}
            title={props.title}
            data-testid="info-tooltip-wrapper"
            overlayStyle={{ maxWidth: props.maxWidth ?? 'auto' }}
        >
            <InfoCircleFilled className={styles['info-icon']} />
        </Tooltip>
    )
}

export default InfoTooltip
